// Live-Refetch für Settings-Pages.
//
// Backend-Seite: die MutationBroadcast-Middleware (internal/middleware/
// mutationbroadcast.go) published nach jeder erfolgreichen Settings-
// Mutation {path, method} auf dem WS-Kanal "settings". Hier filtern
// Pages auf ihre eigenen Endpoints und re-fetchen — ändert ein zweites
// Gerät/Tab etwas, zieht die offene Page sofort nach statt einen alten
// Stand zu zeigen.
//
// Verwendung (in der Page):
//   $effect(() => onSettingsChange(["/v2-api/settings/servers"], load));

import { subscribe as wsSubscribe } from "./ws-hub.svelte";

export function onSettingsChange(
  prefixes: string[],
  refetch: () => void | Promise<void>,
): () => void {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const off = wsSubscribe("settings", (data: unknown) => {
    const path =
      typeof data === "object" && data !== null
        ? (data as { path?: unknown }).path
        : undefined;
    if (typeof path !== "string") return;
    if (!prefixes.some((p) => path.startsWith(p))) return;
    // 200ms-Koaleszenz: Editor-Flows feuern teils mehrere Mutationen
    // hintereinander (z.B. Create + Reorder) — ein Refetch reicht.
    if (timer) return;
    timer = setTimeout(() => {
      timer = undefined;
      void refetch();
    }, 200);
  });
  return () => {
    if (timer) {
      clearTimeout(timer);
      timer = undefined;
    }
    off();
  };
}
